import { Action, combineReducers } from "redux";

import {
  initialNavigationState,
  navigation,
  NavigationState,
} from "./ui/reducers/navigationReducers";
import {
  initialReferenceDataState,
  referenceData,
  ReferenceDataState,
} from "./data/reducers/referenceData";
import {
  initialNutritionPaneState,
  nutritionPane,
  NutritionPaneState,
} from "./ui/reducers/nutritionPaneReducers";
import {
  documentCache,
  DocumentCacheState,
  initialDocumentCacheState,
} from "./data/reducers/documentCache";
import {
  currentDocument,
  CurrentDocumentState,
  initialCurrentDocumentState,
} from "./data/current-document/reducers/currentDocument";
import {
  ErrorState,
  currentError,
  initialErrorState,
} from "./reducers/errorReducers";
import {
  ClipboardState,
  clipboard,
  initialClipboardState,
} from "./reducers/clipboardReducers";
import {
  DatabaseState,
  database,
  initialDatabaseState,
} from "./data/reducers/database";
import { UserState, user, initialUserState } from "./data/reducers/user";
import { LoginState, login, initialLoginState } from "./ui/reducers/login";
import {
  RecipeGridState,
  recipeGrid,
  initialRecipeGridState,
} from "./ui/reducers/recipeGrid";
import {
  OverridesScreenState,
  overridesScreen,
  initialOverridesScreenState,
} from "./ui/reducers/overridesScreen";
import { SavingState, saving, initialSavingState } from "./ui/reducers/saving";
import {
  DocumentEditingState,
  documentEditing,
  initialDocumentEditingState,
} from "./ui/reducers/documentEditing";
import { AlertState, alert, initialAlertState } from "./ui/reducers/alert";
import {
  CompositionCacheState,
  compositionCache,
  initialCompositionCacheState,
} from "./data/reducers/compositionCache";
import {
  DocumentScreenState,
  documentScreen,
  initialDocumentScreenState,
} from "./ui/reducers/documentScreen";
import {
  initialRoutingState,
  RoutingState,
  routing,
} from "./ui/reducers/routing";
import {
  ClientDatabaseState,
  initialClientDatabaseState,
  clientDatabase,
} from "./data/reducers/clientDatabase";
import {
  ClientScreenState,
  initialClientScreenState,
  clientScreen,
} from "./ui/reducers/clientScreen";

export type RootState = {
  navigation: NavigationState;
  nutritionPane: NutritionPaneState;
  currentDocument: CurrentDocumentState;
  referenceData: ReferenceDataState;
  database: DatabaseState;
  clientDatabase: ClientDatabaseState;
  documentCache: DocumentCacheState;
  compositionCache: CompositionCacheState;
  currentError: ErrorState;
  clipboard: ClipboardState;
  user: UserState;
  login: LoginState;
  recipeGrid: RecipeGridState;
  overridesScreen: OverridesScreenState;
  saving: SavingState;
  documentEditing: DocumentEditingState;
  documentScreen: DocumentScreenState;
  clientScreen: ClientScreenState;
  alert: AlertState;
  routing: RoutingState;
};

export const initialRootState: RootState = {
  navigation: initialNavigationState,
  nutritionPane: initialNutritionPaneState,
  currentDocument: initialCurrentDocumentState,
  referenceData: initialReferenceDataState,
  database: initialDatabaseState,
  clientDatabase: initialClientDatabaseState,
  documentCache: initialDocumentCacheState,
  compositionCache: initialCompositionCacheState,
  currentError: initialErrorState,
  clipboard: initialClipboardState,
  user: initialUserState,
  login: initialLoginState,
  recipeGrid: initialRecipeGridState,
  overridesScreen: initialOverridesScreenState,
  saving: initialSavingState,
  documentEditing: initialDocumentEditingState,
  documentScreen: initialDocumentScreenState,
  clientScreen: initialClientScreenState,
  alert: initialAlertState,
  routing: initialRoutingState,
};

const appReducer = combineReducers({
  navigation,
  nutritionPane,
  currentDocument,
  referenceData,
  database,
  clientDatabase,
  documentCache,
  compositionCache,
  currentError,
  clipboard,
  user,
  login,
  recipeGrid,
  overridesScreen,
  saving,
  documentEditing,
  documentScreen,
  clientScreen,
  alert,
  routing,
});

const reducers = (state: any, action: Action) => {
  if (action.type === "USER_LOGOUT") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default reducers;
